import { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { viewNotes } from "app/main/dashboards/main/store/widgetsSlice";
import { useFormContext } from "react-hook-form";
import AuraCommunication from "app/main/apps/common/AuraCommunication";
import dispatchMessage from "app/main/apps/common/AuraFunctions";
import { createNote } from "../../store/orderSlice";

function InternalNotes(props) {
  const { paramData } = props;
  const dispatch = useDispatch();
  const methods = useFormContext();
  const { setValue, getValues } = methods;
  const [loading, setLoading] = useState(false);
  const [submiting, setSubmiting] = useState(false);
  const [notesHistoryList, setNotesHistoryList] = useState([]);
  const formData = getValues();
  const newNoteAttachments = formData?.new_internal_note_attachments || [];

  /**
   * On load functionalities
   */
  useEffect(() => {
    // Add extra OR condition here for undefined ID in case of any new view notes history
    if (paramData?.getNotesData === true && paramData?.reqParam) {
      setLoading(true);
      dispatch(viewNotes(paramData.reqParam)).then(({ payload }) => {
        setLoading(false);
        setNotesHistoryList(payload);
      });
    }
  }, [paramData]);

  /**
   * Reset note and document
   */
  const resetData = (noteItem) => {
    setValue("note", "");
    setValue("new_internal_note_attachments", []);
  };

  /**
   * On Message Send
   */
  const handlePostMessage = () => {
    const formValues = getValues();
    setSubmiting(true);
    const inputData = {
      id: paramData?.reqParam.oid,
      note: formValues.note,
      is_internal: true,
    };
    if (newNoteAttachments?.length > 0) {
      inputData.new_internal_note_attachments = newNoteAttachments?.map(
        (item) => ({ id: item.id })
      );
    }
    dispatch(createNote(inputData)).then((response) => {
      if (!response?.error) {
        setSubmiting(false);
        resetData();
        dispatchMessage(dispatch, "Note posted successfully", "success");
        dispatch(viewNotes(paramData.reqParam)).then(({ payload }) => {
          setNotesHistoryList(payload);
        });
      } else {
        dispatchMessage(dispatch, "Failed to post note", "error");
      }
    });
  };

  return (
    <>
      <AuraCommunication
        parent="internalNotes"
        listItems={notesHistoryList}
        showEmptyNotesHistoryMsg
        handlePostMessage={handlePostMessage}
        loading={loading}
        submiting={submiting}
        {...props}
      />
    </>
  );
}

export default InternalNotes;
